export default class DisableButtonUntilAccept
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...DisableButtonUntilAccept.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$button = this.DOM.$el.querySelector(this.options.selectorButton)
        this.DOM.$checkbox = this.DOM.$el.querySelector(this.options.selectorCheckbox)
        if (this.DOM.$checkbox && this.DOM.$button) {
            this.DOM.$checkbox.addEventListener('change', this.onAcceptChange.bind(this), { passive: true })
            this.onAcceptChange()
        }
    }

    onAcceptChange() {
        this.DOM.$button.disabled = !this.DOM.$checkbox.checked
    }

}

DisableButtonUntilAccept.prototype.defaults = {
    selectorButton: '.js-disableButtonUntilAcceptButton',
    selectorCheckbox: '.js-disableButtonUntilAcceptCheckbox',
}